// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"488":"49ebb214","660":"d50ca2c1","722":"d39ca1a2","897":"6fd892af"}[chunkId] + ".chunk.js";
};